import {
  publishAttractorAtom,
  publishContentNodeAtom,
  publishProfileNodeAtom,
  publishVideoNodeAtom,
} from "./atoms";

export const publishGroups = {
  profile_node: {
    models: ["profile_node", "media_item"],
    singleItems: [],
    atom: publishProfileNodeAtom,
  },
  content_node: {
    models: ["content_node", "media_item"],
    singleItems: [],
    atom: publishContentNodeAtom,
  },
  video_node: {
    models: ["video_node", "media_item"],
    singleItems: [],
    atom: publishVideoNodeAtom,
  },
  attractor: {
    models: ["attract_media_item"],
    singleItems: ["attractor_info"],
    atom: publishAttractorAtom,
  },
};

export type publishAppGroups = keyof typeof publishGroups;
